import { useCallback, useMemo } from 'react';
import { useNavComponentsManager } from '../useNavComponentsManager';
import { isByTagTarget } from './interfaces';
const getTargetComponents = (options, byTagMap) => {
  const {
    exclude = []
  } = options;
  const directTargets = Array.from(isByTagTarget(options) ? byTagMap[options.byTag] : new Set(options.byNames));
  return directTargets.filter(name => !new Set(exclude).has(name));
};
export const useBatchChange = () => {
  const {
    getComponentState,
    setComponentState,
    componentNamesByTag
  } = useNavComponentsManager();
  const getApplyFn = useCallback(({
    updateState,
    actionFilter = () => true
  }) => options => {
    const changed = getTargetComponents(options, componentNamesByTag).filter(name => actionFilter(name, getComponentState(name)));
    changed.forEach(componentName => {
      setComponentState(componentName, updateState);
    });
    return {
      changed
    };
  }, [componentNamesByTag, getComponentState, setComponentState]);
  const show = useMemo(() => getApplyFn({
    updateState: currentState => Object.assign({}, currentState, {
      isOpen: true,
      isLoaded: true
    }),
    actionFilter: (__name, {
      isOpen,
      isLoaded
    }) => !isOpen || !isLoaded
  }), [getApplyFn]);
  const hide = useMemo(() => getApplyFn({
    updateState: currentState => Object.assign({}, currentState, {
      isOpen: false
    }),
    actionFilter: (__name, {
      isOpen
    }) => isOpen
  }), [getApplyFn]);
  const restyle = useCallback((options, style) => getApplyFn({
    updateState: currentState => Object.assign({}, currentState, {
      style: Object.assign({}, currentState.style, style)
    })
  })(options), [getApplyFn]);
  return useMemo(() => ({
    show,
    hide,
    restyle
  }), [hide, restyle, show]);
};